import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

type ContentProps = {
  width?: number
  alignContent?: 'flex-start' | 'center' | 'flex-end'
}

type TextProps = {
  textSize?: number
}

export const Wrapper = styled.div`
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1300;
  margin-top: 52px;
  background-color: rgba(26, 26, 30, 0.5);
`

export const Content = styled.div<ContentProps>`
  display: flex;
  align-items: ${({ alignContent }) => alignContent};
  flex-direction: column;
  justify-content: ${({ alignContent }) => alignContent};
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  padding: ${theme.spacing['2xm']};
  background: ${theme.colors.neutral.white};
  border-radius: ${theme.shapes.borderRadius.md};
  box-shadow: ${theme.effects.boxShadow['rule-01']};
`

export const Texts = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const TitleContainer = styled.div`
  display: flex;
  gap: ${theme.spacing.xs};
  align-items: center;
`

export const Title = styled.h4<TextProps>`
  margin: 0;
  font-family: ${theme.typography.family.bold};
  font-weight: ${theme.typography.weight.lg};
  line-height: ${theme.typography.lineHeight.md};
  color: ${theme.colors.neutral.high};
  font-size: ${({ textSize }) => (textSize ? `${textSize}px` : theme.typography.sizes.lg)};
`

export const CloseButton = styled.button`
  cursor: pointer;
  border: 0;
  padding: 0;
  outline: none;
  background: none;
  margin: 0;

  svg {
    path {
      fill: ${theme.colors.ion.neutral.strong};
    }
  }
`

export const Description = styled.div<TextProps>`
  margin: 0;
  max-width: 450px;
  line-height: ${theme.typography.lineHeight.md};
  color: ${theme.colors.neutral.high};
  font-size: ${({ textSize }) => (textSize ? `${textSize}px` : theme.typography.sizes.sm)};
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.neutral.clear};
  margin: ${theme.spacing.md} 0;
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${theme.spacing.sm};

  .spacer {
    display: flex;
    flex-grow: 1;
  }
`
